import React, { useCallback, useEffect, useMemo, useState } from "react"
import { calculateTotal, calculateTotalWeight, exportToExcel, exportToExcelWithFilter, exportToPDF, funCheckNumber, } from "../../Utility/utility.js"
import { isMobile } from "react-device-detect"
import {
  ErrorCard,
  LoadingCard,
  MainContainer,
} from "../../components"
import { apiRoute, ENUM_CURRENCY_SETTING_VAL, ENUM_ICON_MAP, ENUM_MOD_NAME, ENUM_MOD_PARAMETER, funValidateNoInput, getModMandatory, getModValue, linksUrl, URIEncrypt, } from "../../constants/enum.js"
import { useDispatch, useSelector } from "react-redux"
import { useFetchWithBody, usePost } from "../../api/reactQueryCustomHooks.jsx"
import { faArrowAltCircleDown, faArrowCircleUp, faArrowDown, faArrowDownLong, faArrowDownZA, faArrowUp, faArrowUpAZ, faArrowUpLong, faBarcode, faDotCircle, faFileExcel, faFileInvoice, faFilePdf, faFilter, faFilterCircleXmark, faGem, faMagnifyingGlass, faMagnifyingGlassPlus, faPrint, faSearchPlus, faSquare, faStreetView, } from "@fortawesome/free-solid-svg-icons"
import { Button, Listbox, Select, Popover, PopoverContent, PopoverTrigger, ListboxItem, Input, RadioGroup, Radio, SelectItem, Dropdown, DropdownTrigger, DropdownMenu, DropdownItem, useCalendar, } from "@heroui/react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { DataGrid, } from "@mui/x-data-grid"
import { Box, Checkbox, Autocomplete, ListItemText, MenuItem, OutlinedInput, TextField, } from "@mui/material"
import { toast } from "react-toastify"
import { blue } from "@mui/material/colors"
import { resetStockMemoData, setNewEntryMode, setStockMemoData } from "../../state/memoEntrySlice.jsx"
import { useNavigate } from "react-router-dom"
import { debounce, templateSettings } from "lodash"
import Chip from "@mui/material/Chip";
import jsBarcode from 'jsbarcode';
import html2canvas from 'html2canvas';

import { colorSchemeLight, RowApiModule } from "ag-grid-community"
import { resetDetail, setStockPktData } from "../../state/packetTransferSlice.jsx"

export const ListboxWrapper = ({ children }) => (
  <div className="w-[260px]  border-0 px-1 py-2 rounded-small border-default-200 dark:border-default-100">
    {children}
  </div>
);
const isNumericColumn = (values) => {
  return values.every(v => !isNaN(parseFloat(v)) && isFinite(v));
};
const isValidNumber = (value) => {
  return /^-?\d*\.?\d*$/.test(value);
};
const SortIconNone = () => <span className="text-blue-300" style={{ fontSize: "12px" }}>⇅</span>;
const SortIconAsc = () => <span className="text-blue-400" style={{ fontSize: "12px" }}>▲</span>;
const SortIconDesc = () => <span className="text-blue-400" style={{ fontSize: "12px" }}>▼</span>;
const StockReport = () => {
  const { compCode, compName, compLogo } = useSelector((state) => state.company)
  const { user, menu } = useSelector((state) => state.auth)
  const [selTemplate, setSelTemplate] = useState("")
  const [selStockType, setSelStockType] = useState("P")
  const [selFromSize, setSelFromSize] = useState("")
  const [selToSize, setSelToSize] = useState("")
  const [selIsCertiNo, setSelIsCertiNo] = useState("null")
  const [selIsMix, setSelIsMix] = useState("null")
  const [selLab, setSelLab] = useState("")
  const [selTemplateColumns, setSelTemplateColumn] = useState("")
  const [rows, setRows] = useState([])
  const [exportColumn, setExportColumn] = useState([])
  const [exportFooter, setExportFooter] = useState({})
  const [sortModel, setSortModel] = useState([]);
  const [selectedRows, setSelectedRows] = useState([])
  const [chkselectedRowsData, setChkselectedRowsData] = useState([])
  const [selCustomColumn, setSelCustomColumn] = useState(new Set([]))
  const dispatch = useDispatch()
  const navi = useNavigate()
  const [search, setSearch] = useState({});
  const [selectFilter, setSelectFilter] = useState({});
  const [searchTerm, setSearchTerm] = useState('');
  const [isBarcodePrint, setIsBarcodePrint] = useState(false);
  const [sortConfig, setSortConfig] = useState({ field: null, order: null });
  const [fromPktNo, setFromPktNo] = useState("")
  const [toPktNo, setToPktNo] = useState("")
  const [selStockAt, setSelStockAt] = useState("")
  const [defaultStkAt, setDefaultStkAt] = useState("")
  const [selConvRate, setSelConvRate] = useState("")
  const [CurrencySetting, setCurrencySetting] = useState("")
  const [markupPer, setMarkupPer] = useState("")
  const [selStoneAge, setSelStoneAge] = useState("");
  const [columnVisibilityModel, setColumnVisibilityModel] = useState({
    rapamount: false,
    inw_date: false
  });

  function isMenuExist() {
    const menuApp = menu.appMenu.filter(
      (menuItem) => menuItem.controller === "PacketTransfer"
    )
    const menuUser = menu.userMenu.filter(
      (menuItem) => menuItem.controller === "PacketTransfer"
    )

    if (menuApp.length > 0 && menuUser.length > 0) {
      return true
    } else {
      return false
    }
  }
  
  const { data: masterData = [] } = useFetchWithBody({
    url: apiRoute.stockEntry.reportMasterData,
    queryKey: "StockItemMaster",
  })
  const { isError: isErrorModSet, data: modSetting = [], } = useFetchWithBody({
    url: apiRoute.modSetting.getModSetting,
    queryKey: "fetchModSettingreport",
    inputData: {
      mod_name: ENUM_MOD_NAME.GeneralSettings
    }
  })
  const { data: stoneAgeData = [], } = useFetchWithBody({
    url: apiRoute.stockEntry.getStoneAgeData,
    queryKey: "fetchStoneAgeData",
  })

  useEffect(() => {
    if (modSetting && modSetting.length > 0) {
      const barcodeSetting = getModMandatory(ENUM_MOD_PARAMETER.GeneralSetting.Barcode, modSetting);
      setIsBarcodePrint(barcodeSetting)
      const currSetting = getModValue(ENUM_MOD_PARAMETER.GeneralSetting.CurrencyType, modSetting) ?? ENUM_CURRENCY_SETTING_VAL.RS;
      setCurrencySetting(currSetting)
      const dStkAt = getModValue(ENUM_MOD_PARAMETER.GeneralSetting.DefaultStockDiv, modSetting);
      setDefaultStkAt(dStkAt)
      // if (selStockAt == "" || selStockAt == null)
      setSelStockAt(dStkAt)
    }
  }, [modSetting])
  const funFilterData = (tradeof, fsize, tsize, iscertino, lab, ismix, stockat) => {
    filterStock({
      data: {
        comp_code: compCode.join(","),
        trade_of: tradeof,
        fweight: fsize,
        tweight: tsize,
        iscertino: iscertino,
        lab: lab,
        ismix: ismix,
        stkat: stockat
      }
    })
  }
  const formField = {
    viewFor: "viewFor",
    stockType: "stockType",
    fromSize: "fromSize",
    toSize: "toSize",
    lab: "lab",
    stockAt: "stockAt"
  }
  const handleResetFilter = () => {
    funFilterData(selStockType, null, null, null, null, null, defaultStkAt)
    setSelFromSize("")
    setSelToSize("")
    setSelIsMix("null")
    setSelLab("")
    setSelIsCertiNo("null")
    setSelStockAt(defaultStkAt)
  }
  const { isError: isErrorXlTemp, data: templateSetting = [], mutate: filterTemplate } = usePost({
    url: apiRoute.mapping.GetExcelTemp,
    queryKey: "fetchExcelTemplate",
    onSuccessTasks: (data) => {
      if (data && data.length > 0) {
        const d = data.map((ele) => ele.tb_col_name)
        setSelTemplateColumn([...d])
      }
    }
  })

  const {
    data = [],
    isError,
    isPending,
    mutate: filterStock,
  } = usePost({
    url: apiRoute.stockEntry.fetchReportStock,
    queryKey: "GetStockReportData",
    onSuccessTasks: (data) => {

    }
  })



  useEffect(() => {
    const selItems = finalRows.filter((ele) => selectedRows.includes(ele.id))
    //  const selItems = finalRows
    //   .filter((ele) => selectedRows.includes(ele.id))
    //   .map((item) => ({ ...item, PktType: 'SNG' })); // Add PktType: 'Mix'
    setChkselectedRowsData(selItems)
  }, [selectedRows])

  const handleFilter = () => {
    setSearchTerm("")
    if (selTemplate && selTemplate != "" && selTemplate != null) {
      if (selStockType && selStockType != "" && selStockType != null) {

        funFilterData(selStockType, selFromSize, selToSize, selIsCertiNo, selLab, selIsMix, selStockAt)
      }
      else {
        toast.error("Select Stock Type", {
          "position": "top-center",
          "className": "toast-error",
        })
      }
    }
    else {
      toast.error("Select View For", {
        "position": "top-center",
        "className": "toast-error",
      })
    }
  }
  const [debouncedSearch, setDebouncedSearch] = useState(search);

  useEffect(() => {
    const handler = setTimeout(() => setDebouncedSearch(search), 300); // 300ms delay
    return () => clearTimeout(handler);
  }, [search]);


  /* ---------------- UNIQUE VALUES MAP ---------------- */
  const uniqueValuesMap = useMemo(() => {
    const map = {};
    templateSetting?.forEach(col => {
      const field = col.tb_col_name;
      const values = [...new Set(data.map(d => d[field]))];
      map[field] = values;
    });
    return map;
  }, [data, templateSetting]);

  /* ---------- Filter Unique Values by Search ---------- */
  const filteredUniqueValuesMap = useMemo(() => {
    const newMap = {};

    Object.entries(uniqueValuesMap).forEach(([field, values]) => {
      const searchTerm = debouncedSearch[field]?.toLowerCase() || "";

      newMap[field] = values
        .filter(v => String(v).toLowerCase().includes(searchTerm))
        .sort((a, b) => {
          const numA = parseFloat(a);
          const numB = parseFloat(b);

          // Check if both are valid numbers
          if (!isNaN(numA) && !isNaN(numB)) {
            return numA - numB; // numeric sort
          } else {
            return String(a).localeCompare(String(b)); // alphabetical sort
          }
        });
    });

    return newMap;
  }, [uniqueValuesMap, debouncedSearch]);




  /* ---------- HANDLERS ---------- */

  const handleCustomSearchChange = (field, value) => {
    setSearch(prev => ({ ...prev, [field]: value }));
  };

  const handleSelectChange = (field, values) => {
    setSelectFilter(prev => ({ ...prev, [field]: values }));
  };
  /* ---------- 3-STATE SORTING ---------- */
  const handleSort = (field) => {
    return () => {
      setSortConfig(prev => {
        if (prev.field !== field) return { field, order: "asc" };
        if (prev.order === "asc") return { field, order: "desc" };
        if (prev.order === "desc") return { field: null, order: null };
      });
    };
  };

  /* ---------- FILTER + SORT ---------- */
  const finalRows = useMemo(() => {

    let updatedData = data.map(item => {
      const brated = Number(item.brated) || 0;
      const brate = Number(item.brate) || 0;
      const bweight = Number(item.bweight) || 0;
      const mp = Number(markupPer);

      const markedBrated = !isNaN(mp)
        ? brated + (brated * markupPer) / 100
        : brated;

      const markedBrate = !isNaN(mp)
        ? brate + (brate * markupPer) / 100
        : brate;

      return {
        ...item,
        brated: parseFloat(markedBrated.toFixed(2)),
        amountd: parseFloat((markedBrated * bweight).toFixed(2)), // adjust formula if different

        brate: parseFloat(markedBrate.toFixed(2)),
        amount: parseFloat((markedBrate * bweight).toFixed(2)), // adjust formula if different
      };
    });
    let filtered = updatedData.filter(item => {
      return Object.keys(selectFilter).every(field => {
        const selected = selectFilter[field];
        if (!selected?.length) return true;
        return selected.includes(['brate', 'brated', 'amount', 'amountd', 'crate', 'bweight'].includes(field) ? item[field] : String(item[field]));
      })
      // && Object.keys(debouncedSearch).every(field => {
      //   const s = debouncedSearch[field]?.toLowerCase() || "";
      //   return s ? String(item[field]).toLowerCase().includes(s) : true;
      // });
    });


    if (searchTerm && searchTerm !== "") {
      const lowerSearch = searchTerm.toLowerCase();
      filtered = filtered.filter(item =>
        Object.values(item).some(value =>
          String(value).toLowerCase().includes(lowerSearch)
        )
      );
    }

    if (selStoneAge && selStoneAge !== "") {
      console.log(selStoneAge)
      filtered = filtered.filter((item) => item.stone_age_color == selStoneAge)
    }

    if (sortConfig.field && sortConfig.order) {
      const field = sortConfig.field;
      const values = filtered.map(r => r[field]);
      const isNum = isNumericColumn(values);

      filtered = [...filtered].sort((a, b) => {
        const av = a[field];
        const bv = b[field];
        if (isNum) return sortConfig.order === "asc" ? av - bv : bv - av;
        return sortConfig.order === "asc"
          ? String(av).localeCompare(String(bv))
          : String(bv).localeCompare(String(av));
      });
    }

    return filtered;
  }, [data, selectFilter, sortConfig, searchTerm, markupPer, selStoneAge]);


  let totalPcs = useMemo(
    () =>
      calculateTotal({
        data: chkselectedRowsData && chkselectedRowsData.length > 0 ? chkselectedRowsData : finalRows,
        columnName: "pcs",
      }),
    [finalRows, chkselectedRowsData]
  )

  let totalRap = useMemo(
    () =>
      calculateTotal({
        data: chkselectedRowsData && chkselectedRowsData.length > 0 ? chkselectedRowsData : finalRows,
        columnName: "rapamount",
      }),
    [finalRows, chkselectedRowsData]
  )
  let totalWeight = useMemo(
    () =>
      calculateTotalWeight({
        data: chkselectedRowsData && chkselectedRowsData.length > 0 ? chkselectedRowsData : finalRows,
        columnName: "bweight",
      }),
    [finalRows, chkselectedRowsData]
  )
  const totalAmount = useMemo(() => {
    if (selConvRate && selConvRate != null && selConvRate > 0) {
      const Data = chkselectedRowsData && chkselectedRowsData.length > 0 ? chkselectedRowsData : finalRows;
      console.log(Data.length)
      const convertedData = Data.map(item => ({
        ...item,
        priceInr: (item.bweight * item.brated) * selConvRate
      }));

      // Totals
      console.log(convertedData, "cnv")
      const totalAmt = convertedData.reduce(
        (sum, item) => sum + item.priceInr,
        0
      );

      const totalWeight = Data.reduce(
        (sum, item) => sum + item.bweight,
        0
      );
      // const d = parseFloat(totalAmt) / parseFloat(totalWeight)
      return totalAmt.toFixed(2)

      //setAvgRateRs(funCheckNumber(d).toFixed(2))
    }
    else {
      return calculateTotal({
        data: chkselectedRowsData && chkselectedRowsData.length > 0 ? chkselectedRowsData : finalRows,
        columnName: "amount",
      })
    }


  }, [finalRows, chkselectedRowsData, selConvRate])
  let totalAmountD = useMemo(
    () =>
      calculateTotal({
        data: chkselectedRowsData && chkselectedRowsData.length > 0 ? chkselectedRowsData : finalRows,
        columnName: "amountd",
      }),
    [finalRows, chkselectedRowsData]
  )

  let avgRate = useMemo(() => {
    const d = parseFloat(totalAmountD) / parseFloat(totalWeight)
    return funCheckNumber(d).toFixed(2)
  }, [totalAmountD, totalWeight])


  let avgRateRs = useMemo(() => {
    // if (selConvRate && selConvRate != null && selConvRate > 0) {
    //   const Data = chkselectedRowsData && chkselectedRowsData.length > 0 ? chkselectedRowsData : finalRows;
    //   const convertedData = Data.map(item => ({
    //     ...item,
    //     priceInr: item.brated * selConvRate
    //   }));

    //   // Totals
    //   const totalAmt = convertedData.reduce(
    //     (sum, item) => sum + item.priceInr,
    //     0
    //   );

    //   const totalWeight = Data.reduce(
    //     (sum, item) => sum + item.bweight,
    //     0
    //   );

    //   const d = parseFloat(totalAmt) / parseFloat(totalWeight)
    //   return funCheckNumber(d).toFixed(2)

    //   //setAvgRateRs(funCheckNumber(d).toFixed(2))
    // }
    // else {
    const d = parseFloat(totalAmount) / parseFloat(totalWeight)
    return funCheckNumber(d).toFixed(2)

    //setAvgRateRs(funCheckNumber(d).toFixed(2))
    //}
  }, [totalAmount, totalWeight, selConvRate])


  const itemGridHeadClass = "report-grid-style"
  const objRenderCol = {
    field: '',
    headerName: "",
    headerAlign: "center",
    flex: 1,
    align: 'center',
    sortable: true,
    headerClassName: itemGridHeadClass,

  }

  const [renderColumns, setRenderColumns] = useState([])
  const numericField = ['brate', 'brated', 'amount', 'amountd', 'crate']



  const hasInwardDate = useMemo(() => {
    return templateSetting.some((item) => {
      // normalize to lower case and trim just in case
      const colName = item.tb_col_name?.toLowerCase().trim();
      return colName === "inw_date"; // exact match
    });
  }, [templateSetting]);


  const colrCol = ['fancy_col_int', 'fancy_col_ovrtn', 'grdlcndn', 'certicomment']
  const sel_RenderColumn = useMemo(() => {
    if (templateSetting && templateSetting.length > 0 && data && data.length > 0) {

      const renderCol = templateSetting.map((ele) => {
        return ({
          ...objRenderCol, field: ele.tb_col_name, headerName: ele.xl_col_name,
          minWidth: ele.tb_col_name == 'l_code' ? 130 :
            ele.tb_col_name == "stoneid" ? 140 : ele.tb_col_name == "s_name" ? 190 : colrCol.includes(ele.tb_col_name) ? 140 : 110,
          valueFormatter: (params) => {
            if (params != "" && numericField.includes(ele.tb_col_name)) {
              const value = Number(params);
              return isNaN(value) ? params : value.toFixed(2);
            }
            else return params
          },

          renderHeader: (params) => {

            const field = params.colDef.field;

            const sortIcon =
              sortConfig.field !== field ? <SortIconNone /> :
                sortConfig.order === "asc" ? <SortIconAsc /> :
                  sortConfig.order === "desc" ? <SortIconDesc /> :
                    <SortIconNone />;

            return (
              <Box sx={{ display: "flex", flexDirection: "column", padding: "2px" }}>

                {/* Title + Sort Button */}
                <Box className={` flex items-center justify-between ${ele.tb_col_name == "s_name" ? " bg-indigo-50 text-indigo-700" :
                  ele.tb_col_name == "sh_name" ? "bg-cyan-50 text-cyan-700" :
                    ele.tb_col_name == "bweight" ? "bg-pink-50 text-pink-700" :
                      ele.tb_col_name == "q_name" ? "bg-lime-50 text-lime-700"
                        : "text-slate-900"}`}
                  // sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
                  onClick={handleSort(field)}
                  style={{ cursor: "pointer" }}
                >
                  <div style={{ fontSize: "0.655rem" }} className=" w-full text-center flex  justify-center items-center leading-snug whitespace-normal h-7 overflow-hidden" >
                    {ele.xl_col_name}
                  </div>
                  {sortIcon}
                </Box>

                <Autocomplete
                  multiple
                  size="small"
                  options={(filteredUniqueValuesMap[field] || []).filter(opt => opt != null)} // always fallback to empty array
                  value={selectFilter[field] || []}
                  onChange={(e, newValue) => handleSelectChange(field, newValue)}
                  disabled={!filteredUniqueValuesMap[field] || filteredUniqueValuesMap[field].length === 0}
                  noOptionsText="No options available"
                  renderTags={() => null}
                  slotProps={{
                    chip: {
                      size: "small",
                      sx: { height: 20, fontSize: "10px", padding: "0 4px", "& .MuiChip-label": { padding: 0 } }
                    },
                    input: { sx: { padding: "2px 0px !important", fontSize: "11px" } },
                    popper: { sx: { fontSize: "12px" } },
                    listbox: {
                      sx: {
                        fontSize: "11px",
                        "& .MuiAutocomplete-option": {
                          padding: "2px 8px", minHeight: "28px",
                          "&.Mui-selected": {
                            backgroundColor: "#f3ea6fff !important",
                            color: "#000 !important",
                          },
                          // Change background color when focused via keyboard navigation
                          "&.Mui-focused": {
                            backgroundColor: "#7cf3bbff",
                          },
                        },

                      }
                    }
                  }}
                  sx={{
                    "& .MuiAutocomplete-inputRoot": { padding: "0px 4px !important", minHeight: "30px", background: "#FFFFFF" },
                    "& .MuiOutlinedInput-root": { padding: "0px !important", height: "30px" },

                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Search & Select"
                      variant="outlined"
                      size="small"
                      inputProps={{
                        ...params.inputProps, // ⚡ make sure inputProps exist
                        autoComplete: "off"
                      }}
                      sx={{
                        width: field === "l_code" ? "120px" : field === "stoneid" ? "130px" : field === "s_name" ? "160px" : "100px",
                        "& .MuiInputLabel-root": { fontSize: "11px" }
                      }}
                    />
                  )}
                />
              </Box>
            );
          },
          renderCell: ({ row }) =>
            ele.tb_col_name === "videofile" ? (
              <a href={row.videofile} target="_blank" style={{ color: "#0d47a1" }} >
                {row.videofile}
              </a>
            ) :
              ele.tb_col_name === "imgfile" ? (
                <a href={row.imgfile} target="_blank" style={{ color: "#0d47a1" }} >
                  {row.imgfile}
                </a>
              )
                : ele.tb_col_name === "reportno" ? (
                  <a href={row.labid && row.labid != "" ? row?.labid.toUpperCase() == "IGI" ? 'https://www.igi.org/reports/verify-your-report?r=' + row.reportno
                    : row?.labid.toUpperCase() == "GIA" ? 'https://www.gia.edu/report-check?reportno=' + row.reportno : "" : ""} target="_blank" style={{ color: "#0d47a1" }} >
                    {row.reportno}
                  </a>
                ) : ele.tb_col_name === "certfile" ? (<a href={row.labid && row.labid != "" ? row?.labid.toUpperCase() == "IGI" ? 'https://www.igi.org/reports/verify-your-report?r=' + row.reportno
                  : row?.labid.toUpperCase() == "GIA" ? 'https://www.gia.edu/report-check?reportno=' + row.reportno : "" : ""} target="_blank" style={{ color: "#0d47a1" }} >
                  {row.labid && row.labid != "" ? row?.labid.toUpperCase() == "IGI" ? 'https://www.igi.org/reports/verify-your-report?r=' + row.reportno
                    : row?.labid.toUpperCase() == "GIA" ? 'https://www.gia.edu/report-check?reportno=' + row.reportno : "" : ""}
                </a>) : ele.tb_col_name === "stoneid" ? (
                  <div style={{ background: row?.stone_age_color || "#ffffff" }} className={`flex gap-2 items-center justify-center  `}>
                    {row?.stone_age_symbol != "" ?
                      <FontAwesomeIcon style={{ color: row?.stone_age_color || "#585656", fontSize: "0.8rem" }} icon={ENUM_ICON_MAP[row?.stone_age_symbol?.toLowerCase()]}></FontAwesomeIcon>
                      : ""}
                    <div style={{}}>  {row.stoneid} </div></div>
                ) : (
                  <div className={` h-7 ${ele.tb_col_name == 'stkavailable' ? row[ele.tb_col_name] == 'MEMO' ? 'text-red-500' : 'text-green-700' :
                    ele.tb_col_name == "s_name" ? " bg-indigo-50 text-indigo-700" :
                      ele.tb_col_name == "sh_name" ? "bg-cyan-50 text-cyan-700" :
                        ele.tb_col_name == "bweight" ? "bg-pink-50 text-pink-700" :
                          ele.tb_col_name == "q_name" ? "bg-lime-50 text-lime-700"
                            : ""

                    }`}> {ele.tb_col_name == "bweight" ? row[ele.tb_col_name].toFixed(2) : row[ele.tb_col_name]}</div>
                ),


        })
      })
      setRenderColumns([...renderCol, { ...objRenderCol, field: "rapamount", headerName: 'Rap Amt' }])
      return renderCol
    }
    else
      return []
  }, [templateSetting, data, search, selectFilter, filteredUniqueValuesMap, sortConfig])

  const sel_ExportColumn = useMemo(() => {
    if (templateSetting && templateSetting.length > 0) {
      const exportCol = templateSetting.map((ele) => {
        return ({
          uid: ele.tb_col_name, name: ele.xl_col_name, type: ['bweight', 'amount', 'amountd', 'pcs'].includes(ele.tb_col_name) ? "number" : ""
        })
      })
      setExportColumn(exportCol)
      return exportCol
    }
    else
      return []
  }, [templateSetting])

  const sel_ExportFooter = useMemo(() => {
    if (templateSetting && templateSetting.length > 0) {
      const exportFooter = templateSetting.map((ele) => {
        return ({
          [ele.tb_col_name]: ele.tb_col_name == "bweight" ? totalWeight :
            ele.tb_col_name == "pcs" ? totalPcs :
              ele.tb_col_name == "amount" ? totalAmount :
                ele.tb_col_name == "amountd" ? totalAmountD : ''
        })
      })
      const combined = Object.assign({}, ...exportFooter);
      setExportFooter(combined)
      return combined
    }
    else
      return []
  }, [templateSetting])

  const handleSelectAll = () => {
    const allKeys = templateSetting.map(ele => ele.tb_col_name);
    setSelCustomColumn(new Set(allKeys));
  }
  // console.log(selCustomColumn)
  const handleClearCustomFilter = () => {
    setSelCustomColumn(new Set([]))
  }
  useEffect(() => {
    if (selCustomColumn.size > 0) {
      const selCol = Array.from(selCustomColumn).join(",").split(",")
      const custCol = sel_RenderColumn.filter((ele) => selCol.includes(ele.field))
      const custExportCol = sel_ExportColumn.filter((ele) => selCol.includes(ele.uid))
      const custExportFooter = Object.keys(sel_ExportFooter).filter((ele) => selCol.includes(ele))
      setRenderColumns(custCol)
      setExportColumn(custExportCol)
      setExportFooter(custExportFooter)
    }
    else {
      setRenderColumns(sel_RenderColumn)
      setExportColumn(sel_ExportColumn)
      setExportFooter(sel_ExportFooter)
    }
  }, [selCustomColumn])

  const handleAutoCompleteChange = (val, name) => {
    if (name == formField.viewFor) {
      setSelTemplate(val)
      filterTemplate({
        data: {
          tempid: val
        }
      })
    }
  }

  const getTempName = () => {
    if (masterData && masterData?.tempMaster.length > 0) {
      const fil = masterData?.tempMaster.filter((ele) => ele.TempleteID == selTemplate)
      return fil && fil.length > 0 ? fil[0].TempleteName : "SinglePktStockView"
    }
  }

  const exportExcel = () => {
    exportToExcelWithFilter({
      data: finalRows,
      downloadFileName: getTempName(),
      exportColumns: exportColumn,
      companyName: compName.join(","),
      logo: compLogo?.length > 1 ? "" : compLogo[0],
      currency: CurrencySetting
    })
  }

  const exportPdf = () => {
    exportToPDF(
      {
        data: finalRows,
        downloadFileName: getTempName(),
        exportColumns: exportColumn,
        exportReportType: "",
        downloadFileheader: [],
        downloadDataFooter: { ...exportFooter, bweight: totalWeight, pcs: totalPcs, amount: totalAmount, amountd: totalAmountD },
      })
  }

  const handleClearGridFilters = () => {
    setSelectFilter({})
    setSearch({})

  }

  const handleMemo = () => {
    if (selectedRows && selectedRows.length > 0) {
      dispatch(setNewEntryMode(true))
      dispatch(setStockMemoData(chkselectedRowsData))
      if (selStockType == "P")
        navi(linksUrl.saleEntry.polishDiamond + URIEncrypt.Sale + "/" + URIEncrypt.Polish + "/" + URIEncrypt.SinglePacket + linksUrl.memoEntry.createMemoEntry)
      else if (selStockType == "R")
        navi(linksUrl.saleEntry.roughDiamond + URIEncrypt.Sale + "/" + URIEncrypt.Rough + "/" + URIEncrypt.SinglePacket + linksUrl.memoEntry.createMemoEntry)

    }
    else {
      toast.error("First Select Items", {
        "position": "top-center"
      })
    }
  }
  const handleStockTransfer = () => {
    if (selectedRows && selectedRows.length > 0) {
      dispatch(resetDetail())
      dispatch(setStockPktData({ fromLocation: selStockAt, data: chkselectedRowsData }))
      if (selStockType == "P")
        navi(linksUrl.packetTrasnferEntry.polishStock + "/" + URIEncrypt.Polish + "/" + URIEncrypt.SinglePacket + linksUrl.packetTrasnferEntry.createsingleEntry)
      else if (selStockType == "R")
        navi(linksUrl.packetTrasnferEntry.roughStock + "/" + URIEncrypt.Rough + "/" + URIEncrypt.SinglePacket + linksUrl.packetTrasnferEntry.createsingleEntry)

    }
    else {
      toast.error("First Select Items", {
        "position": "top-center"
      })
    }
  }
  const handleSearchChange = (e) => {
    const text = e.target.value;
    setSearchTerm(text); // updates input display instantly
  };

  const handleRowSelectionChange = (newSelection) => {

    const selItems = finalRows.filter((ele) => newSelection.includes(ele.id))
    const memoItems = selItems.filter((ele) => ['MEMO'].includes(ele.stkavailable))

    if (memoItems && memoItems.length > 0) {
      if (!toast.isActive("memosel")) {
        toast.error("You Can't Select Memo Items", {
          position: "top-center",
          toastId: "memosel"
        })
      }
      const ids = memoItems.map(ele => ele.id)
      const newSel = newSelection.filter(ele => !ids.includes(ele))
      setSelectedRows(newSel)
      //console.log(ids, newSelection, newSel)
    }
    else {
      setSelectedRows(newSelection);
    }

  }
  const handleRemoveTag = (field, value) => {
    const updated = selectFilter[field].filter((v) => v !== value);

    handleSelectChange(field, updated);
    // ⬆️ same function Autocomplete uses to update states
  };

  const getColName = (colName) => {
    if (templateSetting && templateSetting.length > 0) {
      const filData = templateSetting.filter((ele) => ele.tb_col_name == colName)
      if (filData && filData.length > 0) {
        return filData[0].xl_col_name
      }
      else return colName
    }
    else return ""
  }

  // const handleGenerateBarcode = () => {
  //   try {
  //     if (selectedRows && selectedRows.length > 0) {
  //       if (chkselectedRowsData.length === 0) return;

  //       const printWindow = window.open('', '_blank');
  //       if (!printWindow) {
  //         alert('Please allow pop-ups for this site.');
  //         return;
  //       }

  //       let htmlContent = `
  //     <!DOCTYPE html>
  //     <html>
  //     <head>
  //       <title>Diamond Cards Print</title>
  //       <style>
  //         @page { size: 80mm 50mm; margin: 0; }
  //         body { margin: 0; padding: 0; font-family: Arial; width: 80mm; border:0px solid;}
  //         .diamond-card { border:0px solid; width: 38mm; height: 20mm; padding: 1mm; display: flex; box-sizing: border-box; page-break-after: always; }
  //         .left-side { width: 100%; padding-right: 2mm; display: flex; flex-direction: column; justify-content: space-between; }
  //         .right-side { width: 40%; padding-left: 2mm; display: flex; flex-direction: column; font-size: 12px; }
  //         .diamond-title, .diamond-info { font-weight: bold; font-size: 12px; margin-bottom: 0mm; }
  //         .barcode-container { width: 100%;   }
  //         .barcode { width: 100%; height: 100%; }
  //       </style>
  //     </head>
  //     <body>
  //   `;


  //       // Create cards
  //       chkselectedRowsData.forEach(diamond => {
  //         htmlContent += `
  //       <div class="diamond-card">
  //         <div class="left-side">
  //           <div>
  //             <div class="diamond-info">${diamond.l_code}-${diamond.pktno}</div>
  //             <div class="diamond-info">${diamond.s_name}</div>
  //           </div>
  //           <div class="barcode-container">
  //             <svg id="barcode-${diamond.l_code}-${diamond.pktno}" class="barcode"></svg>
  //           </div>
  //         </div>

  //       </div>
  //     `;
  //       });

  //       // Insert js + barcode generation using onload (Critical Fix)
  //       htmlContent += `
  //     <script src="https://cdn.jsdelivr.net/npm/jsbarcode@3.11.5/dist/JsBarcode.all.min.js"></script>
  //     <script>
  //       window.onload = function() {

  //         ${chkselectedRowsData.map(d =>
  //         `
  //             try {
  //               JsBarcode(
  //                 document.getElementById("barcode-${d.l_code}-${d.pktno}"),
  //                 "${d.l_code}#${d.pktno}",
  //                 {
  //                   format: "CODE128",
  //                   lineColor: "#000",
  //                   width: 2,
  //                   height: 50,
  //                   displayValue: false,
  //                   margin: 5
  //                 }
  //               );
  //             } catch(err) {
  //               console.error("Barcode error for ${d.l_code}-${d.pktno}", err);
  //             }
  //           `
  //       ).join("")}

  //         // Wait to ensure SVG rendering is complete
  //         setTimeout(() => {
  //           window.print();
  //           window.close();
  //         }, 300);
  //       };
  //     </script>
  //     </body>
  //     </html>
  //   `;

  //       printWindow.document.open();
  //       printWindow.document.write(htmlContent);
  //       printWindow.document.close();
  //     }
  //     else {
  //       toast.error("First Select Packets", {
  //         "position": "top-center"
  //       })
  //     }

  //   } catch (err) {
  //     console.error('Barcode generation error:', err);
  //     toast.error('Failed to generate barcode');
  //   }
  // }

  const funGetBarcode = (BarData) => {
    try {
      if (BarData && BarData.length > 0) {
        //if (chkselectedRowsData.length === 0) return;

        const printWindow = window.open('', '_blank');
        if (!printWindow) {
          alert('Please allow pop-ups for this site.');
          return;
        }
        let htmlContent = `
      <!DOCTYPE html>
      <html>
      <head>
        <title>Diamond Cards Print</title>
        <style>
          @page { size: 50mm 25mm; margin: 0; }
          body { margin:0mm; padding: 0; font-family: Arial; width: 50mm;  height:25mm;border:0px solid;}
          .diamond-card {margin-bottom: 2mm; border:0px solid; width: 48mm; height:23mm; padding: 1mm; box-sizing: border-box; page-break-after: always; justify-content: flex-start; }
          .left-side { width:100%; padding: 0mm; display: flex; flex-direction: column; justify-content: flex-start;  align-items: flex-start;}
          .mid-side { width:100%;  display: flex; flex-direction: column; justify-content: flex-start;  align-items: flex-start;}
          .right-side { width: 100%; padding: 0mm; display: flex; flex-direction: column; justify-content: flex-start;  align-items: flex-start;}
          .diamond-title, .diamond-info { font-weight: bold; padding:0;line-height: 1; margin:0;   font-size: 7px; margin-bottom: 0mm;   }
          .barcode-container { width: 100%; height: 8mm;    }
          .barcode { width: 100%; height: 100%; }
          .text-center {width:60%;   font-size:12px; font-weight: bold; padding:0;   margin-bottom: 0mm;   }
          .flex{display:flex; justify-content:start;   flex-direction: row;  border:0px solid; align-items: center;margin-left:2px;}
          .wlt{width:40%; border:0px solid; font-weight: bold; padding:0;line-height: 1; margin:0;   font-size: 7px; margin-bottom: 0mm;   }
          .wrt{width:60%; border:0px solid;   font-weight: bold; padding:0;line-height: 1; margin:0;   font-size: 12px; margin-bottom: 0mm;  }
          .flexbox{display: grid;  grid-template-columns: 1fr 1fr 1fr; grid-auto-rows: auto; width: 100%; margin-left:2px; align-items: start;}
          .flextop{width: 100%;display:flex; justify-content:flex-start; border:0px solid; margin-left:2px; align-items: center;}
          .pd{padding:0.1mm}
          .smfont{font-size:8px;}
        </style>
      </head>
      <body>
    `;
        BarData.forEach(diamond => {
          htmlContent += `
        <div class="diamond-card">
         <div class="flex">
          <div class="barcode-container">  <svg id="barcode-${diamond.l_code}-${diamond.pktno}" class="barcode"></svg></div>
          </div>
          <div class='flextop'>
            <div class="text-center">${diamond.pktno} <span class="smfont"> (${diamond.l_code}-${diamond.pktno})</span></div>
            <div class="wlt">${diamond.s_name}</div>
          </div>
           <div class="pd"></div>
        <div class="flexbox">
          <div class="left-side">
            <div class="diamond-info">Wt : ${diamond.bweight}</div>
            <div class="diamond-info">Color : ${diamond.sh_name}</div>
            <div class="diamond-info">Clarity : ${diamond.q_name}</div>
             
           </div>
          <div class="mid-side">
            <div class="diamond-info">Cut : ${diamond.cut_code}</div>
            <div class="diamond-info">Pol : ${diamond?.polish_code || ''}</div>
            <div class="diamond-info">Sym : ${diamond?.sym_code || ''}</div>
             
          </div>
          <div class="right-side">
            <div class="diamond-info">Table : ${diamond.tbl_ptg || ''}</div>
            <div class="diamond-info">Depth : ${diamond.tbl_dpth || ''}</div>
           <div class="diamond-info">Flrn  : ${diamond.flrn}</div>
           
          </div>
        </div>
         <div class="pd"></div>
        <div class='flex'>
       
            <div class="wlt">MsrMnt : ${diamond?.stn_lnth ||''}${diamond?.dia!=0? ` x ${diamond?.dia ||''}`:"" }</div>
            <div class="wrt">${diamond?.labid || ''}  ${diamond?.reportno?`: ${diamond?.reportno || ''}`:""}</div>
        </div>

        </div>
      `;
        });
        htmlContent += `
      <script src="https://cdn.jsdelivr.net/npm/jsbarcode@3.11.5/dist/JsBarcode.all.min.js"></script>
      <script>
        window.onload = function() {

          ${BarData.map(d =>
          `
              try {
                JsBarcode(
                  document.getElementById("barcode-${d.l_code}-${d.pktno}"),
                  "${d.l_code}#${d.pktno}",
                  {
                    format: "CODE128",
                    lineColor: "#000",
                    width: 1,
                    height: 20,
                    displayValue: false,
                    margin: 0
                  }
                );
              } catch(err) {
                console.error("Barcode error for ${d.l_code}-${d.pktno}", err);
              }
            `
        ).join("")}

          // Wait to ensure SVG rendering is complete
          setTimeout(() => {
            window.print();
            window.close();
          }, 300);
        };
      </script>
      </body>
      </html>
    `;
        printWindow.document.open();
        printWindow.document.write(htmlContent);
        printWindow.document.close();
      }
      else {
        toast.error("First Select Packets", {
          "position": "top-center"
        })
      }

    } catch (err) {
      console.error('Barcode generation error:', err);
      toast.error('Failed to generate barcode');
    }
  }

  const handleParameterGenerateBarcode = () => {
    funGetBarcode(chkselectedRowsData)
  }
  const handlePktNoChange = (val, name) => {
    if (funValidateNoInput(val)) {
      if (name == 'fPktNo')
        setFromPktNo(val)
      else if (name == "tPktNo")
        setToPktNo(val)
    }
  }

  const handleMuliBarcode = () => {

    const isNumeric = (val) => /^\d+(\.\d+)?$/.test(val);

    const filteredRows = finalRows.filter(ele =>
      isNumeric(ele.pktno) &&
      Number(ele.pktno) >= fromPktNo &&
      Number(ele.pktno) <= toPktNo
    ).sort((a, b) => Number(a.pktno) - Number(b.pktno));;
    if (filteredRows && filteredRows.length > 0)
      funGetBarcode(filteredRows)
    else {
      toast.error("Packets Not Found", {
        position: "top-center"
      })
    }
  }

  const handleConvRate = (val) => {
    if (funValidateNoInput(val))
      setSelConvRate(val)
  }

  const handleMarkupChange = (e) => {
    const val = e.target.value;
    if (isValidNumber(val)) {
      setMarkupPer(val);
    }
  }

  const handleCheckboxChange = (e) => {
    const checked = e.target.checked;
    setColumnVisibilityModel((prev) => ({
      ...prev,
      inw_date: checked,

    }));
  }
  //console.log(data)
  if (isPending) {
    return <LoadingCard />
  }

  if (isError) {
    return <ErrorCard />
  }

  //console.log(selectFilter)
  return (
    <div>



      <MainContainer pageName="Single Packet Stock View" info={[]} breadcrumbs={["Reports", "single Packet Stock View"]}>
        <div className={`  w-full  bg-white shadow border-1 p-2   mb-2`}>
          <div className={` flex   items-center   flex-wrap  sm:flex-nowrap md:flex-wrap w-full items-center gap-4  `}>
            {/* <div className={`flex  gap-4 ${isMobile ? '' : ''}    items-center `}> */}
            <Select
              size="sm"
              isRequired
              name={formField.viewFor}
              color={"danger"}
              label={"View For"}
              eventResizeFeature={true}
              selectionMode="single"
              labelPlacement="outside"
              showScrollIndicators={true}
              placeholder={"select"}
              className={`w-full md:w-40 sm:w-40}  font-semibold`}
              classNames={{
                label: "text-xs text-black font-bold",
              }}
              isClearable={false}
              variant="flat"
              isVirtualized
              items={
                masterData && masterData?.tempMaster ? masterData.tempMaster : []
              }
              onChange={(e) => handleAutoCompleteChange(e.target.value, formField.viewFor)}
              selectedKeys={[selTemplate]}
            >
              {(list) => (
                <SelectItem
                  key={list.TempleteID}
                >
                  {list.TempleteName}
                </SelectItem>
              )}
            </Select>
            <Select
              size="sm"
              isRequired
              name={formField.stockType}
              color={"success"}
              label={"Stock Type"}
              eventResizeFeature={true}
              selectionMode="single"
              labelPlacement="outside"
              showScrollIndicators={true}
              placeholder={"select"}
              className={`w-full md:w-40 sm:w-40}  font-semibold`}
              // className={`${isMobile ? "w-40" : "w-28"}  font-semibold`}
              classNames={{
                label: "text-xs text-black font-bold",
              }}
              isClearable={false}
              variant="flat"
              onChange={(e) => setSelStockType(e.target.value)}
              selectedKeys={[selStockType]}
            >

              <SelectItem key="P">Polish</SelectItem>
              <SelectItem key="R">Rough</SelectItem>

            </Select>
            <Select
              size="sm"
              name={formField.stockAt}
              color={"success"}
              label={"Stock At"}
              eventResizeFeature={true}
              selectionMode="single"
              labelPlacement="outside"
              showScrollIndicators={true}
              placeholder={"select"}
              className={`w-full md:w-40 sm:w-40}  font-semibold`}
              // className={`${isMobile ? "w-40" : "w-28"}  font-semibold`}
              classNames={{
                label: "text-xs text-black font-bold",
              }}
              isClearable={false}
              variant="flat"
              items={
                masterData && masterData?.stkMaster ? masterData.stkMaster : []
              }
              onChange={(e) => setSelStockAt(e.target.value)}
              selectedKeys={[selStockAt]}
            >
              {(list) => (
                <SelectItem
                  key={list.AC_ID}
                >
                  {list.AC_DESC}
                </SelectItem>
              )}


            </Select>

            <div className={`flex  gap-4 ${isMobile ? '' : ''} justify-center   items-center `}>
              <Input
                type={"number"}
                name={formField.fromSize}
                placeholder={"From Size"}
                label={"Form Size"}
                labelPlacement="outside"
                value={selFromSize}
                variant={"bordered"}
                onChange={(e) => setSelFromSize(e.target.value)}
                size={"sm"}
                className="sm:w-24 md:w-24 w-1/2"
                classNames={{
                  label: "text-xs text-black font-bold",
                }}
              ></Input>
              <Input
                type={"number"}
                name={formField.toSize}
                placeholder={"To Size"}
                label={"To Size"}
                labelPlacement="outside"
                value={selToSize}
                variant={"bordered"}
                onChange={(e) => setSelToSize(e.target.value)}
                size={"sm"}
                className="sm:w-24 md:w-24 w-1/2"
                classNames={{
                  label: "text-xs text-black font-bold",
                }}
              ></Input>

            </div>
            <Select
              size="sm"
              name={formField.lab}
              label={"Lab"}
              color="warning"
              eventResizeFeature={true}
              selectionMode="single"
              labelPlacement="outside"
              showScrollIndicators={true}
              placeholder={"select"}
              className={`w-full md:w-36 sm:w-36}  font-semibold`}
              // className="max-w-28 font-semibold"
              classNames={{
                label: "text-xs text-black font-bold",
              }}
              isClearable={true}
              variant="flat"
              isVirtualized
              items={
                masterData && masterData?.labMaster ? masterData.labMaster : []
              }
              onChange={(e) => setSelLab(e.target.value)}
              selectedKeys={[selLab]}
            >
              {(list) => (
                <SelectItem
                  key={list.LabId}
                >
                  {list.LabId}
                </SelectItem>
              )}
            </Select>


            <div className=" flex gap-4 ">

              <RadioGroup label=" " size="sm" color="success"
                value={selIsCertiNo} onValueChange={setSelIsCertiNo}
                className="text-xs" orientation={`${isMobile ? "horizontal" : "vertical"}`}>
                <Radio value="null">All</Radio>
                <Radio value="1">Certi</Radio>
                <Radio value="0">NonCerti</Radio>
              </RadioGroup>

              <RadioGroup label=" " size="sm" color="danger"
                value={selIsMix} onValueChange={setSelIsMix}
                className="text-xs" classNames={{ label: "text-xs" }} orientation={`${isMobile ? "horizontal" : "vertical"}`}>
                <Radio value="null">All</Radio>
                <Radio value="0">Single</Radio>
                <Radio value="1">Mix</Radio>
              </RadioGroup>
            </div>
            <div className={`flex gap-4 ${isMobile ? "w-full" : ""} justify-center items-center `}>
              {/* </div>
            <div className={`flex  items-center gap-2 `}> */}
              <Button
                size="sm"
                color="primary"
                className="bg-slate-700 sm:w-22 md:w-22 w-full "
                startContent={<FontAwesomeIcon icon={faMagnifyingGlass} />}
                onPress={handleFilter}

              // isLoading={isPending}
              >
                Find
              </Button>
              <Button
                style={{ marginLeft: "5px" }}
                color="primary"
                size="sm"
                className="sm:w-22 md:w-22 w-full"
                startContent={<FontAwesomeIcon icon={faFilter} />}
                onPress={handleResetFilter}
              >
                Reset
              </Button>
            </div>
          </div>
        </div>

        <div style={{ display: "flex", flexDirection: "row", gap: 4 }}>
          {Object.entries(selectFilter).map(([field, values]) => (
            <div key={field} style={{ display: "flex", alignItems: "center", gap: 6, flexWrap: "wrap" }}>
              <strong style={{ fontSize: "0.6rem" }} className="text-xs uppercase"> {values.length > 0 ? getColName(field) + " :" : ""} </strong>
              {values.map(value => (
                <Chip
                  key={`${field}-${value}`}
                  label={value}
                  onDelete={() => handleRemoveTag(field, value)}
                  size="small"
                  color="primary"
                  variant="outlined"
                  sx={{ height: 22, fontSize: "11px" }}
                />
              ))}
            </div>
          ))}
        </div>


        <div className="" >

          <div className={` ${isMobile ? "" : "flex"}  gap-5 items-center  justify-between my-5`}>
            {selectFilter && Object.keys(selectFilter).length > 0 ? <>
              {/* <Chip onClick={handleClearGridFilters} size="sm" variant="bordered" className="cursor-pointer text-gray-700">
                <FontAwesomeIcon className="text-orange-600" icon={faFilterCircleXmark}></FontAwesomeIcon> Remove Filters</Chip> */}
              <Chip icon={<FontAwesomeIcon style={{ fontSize: "12px", color: "#ff6a00" }}
                icon={faFilterCircleXmark}></FontAwesomeIcon>} label=" Remove Filters"
                onClick={handleClearGridFilters} size="small"
                variant="outlined"
                className="cursor-pointer text-gray-700"
                sx={{
                  color: "#383737ff",
                  // Text color,
                  // borderColor: "#6e6e6eff",         // Border color
                  "& .MuiChip-label": {
                    fontSize: "11px"
                  },
                  "& .MuiChip-icon": {
                    marginLeft: "4px"
                  },
                }}>
              </Chip>

            </>
              : "-"}
            <div className={`${isMobile ? " mt-2" : ""} flex gap-2  justify-end`}>
              <Button size="sm" className="bg-blue-700" isDisabled={finalRows.length <= 0 ? true : false} color="danger"
                startContent={<FontAwesomeIcon icon={faFileInvoice} />}
                onPress={handleMemo}> {isMobile ? "Memo" : "Generate Memo"}</Button>
              {isMenuExist() ? <Button size="sm" className="bg-purple-800" isDisabled={finalRows.length <= 0 ? true : false} color="danger"
                startContent={<FontAwesomeIcon icon={faGem} />}
                onPress={handleStockTransfer}> {isMobile ? "Transfer" : "Stock Transfer"}</Button> : ""}
              {isBarcodePrint ? <>
                {/* <Button size="sm" className="bg-red-600" isDisabled={finalRows.length <= 0 ? true : false} color="danger"
                  startContent={<FontAwesomeIcon icon={faPrint} />}
                  onPress={handleGenerateBarcode}> {"Barcode"}</Button> */}
                <Button size="sm" className="bg-red-600" isDisabled={finalRows.length <= 0 ? true : false} color="danger"
                  startContent={<FontAwesomeIcon icon={faPrint} />}
                  onPress={handleParameterGenerateBarcode}> {"Barcode"}</Button>
              </> : ""}
              <Popover placement="bottom" showArrow={true} radius="none" className="border-2 border-orange-500"
                // shouldCloseOnBlur={false}
                //  disableAnimation={false}
                shouldBlockScroll={true}  >
                <PopoverTrigger>

                  <Button size="sm" variant="flat" color="danger" isDisabled={templateSetting && templateSetting.length > 0 ? false : true}
                    startContent={<FontAwesomeIcon icon={faStreetView} ></FontAwesomeIcon>}
                  >Custom View</Button>
                </PopoverTrigger>
                <PopoverContent>
                  <div className="m-2 text-center  w-full flex gap-4 justify-between  items-center">
                    <h6 className="font-semibold  m-0 bg-gray-50  ">Select columns</h6>
                    <div className="flex-justify-end items-center">
                      {/* <Button size="sm" color="danger" className="font-semibold h-6 bg-blue-700" onPress={handleCustomView}>Apply</Button> */}

                      <Button variant="flat" radius="full" size="sm" color="warning"
                        className="font-semibold h-6 "
                        onPress={handleSelectAll}>
                        {/* <FontAwesomeIcon className="text-xl" icon={faSquare} ></FontAwesomeIcon> */}
                        Select All</Button>
                      <Button variant="light" radius="full" isIconOnly={true} size="sm" color="danger"
                        className="font-semibold h-6 "
                        onPress={handleClearCustomFilter}>
                        <FontAwesomeIcon className="text-xl" icon={faFilterCircleXmark} ></FontAwesomeIcon>
                      </Button>
                    </div>
                  </div>

                  <div className="flex flex-col gap-2 bg-white">
                    <ListboxWrapper>
                      <Listbox
                        disallowEmptySelection
                        aria-label="Multiple selection example"
                        selectedKeys={selCustomColumn}
                        selectionMode="multiple"
                        variant="light"
                        color="danger"
                        radius="none"
                        isVirtualized
                        hideEmptyContent={true}
                        virtualization={{
                          maxListboxHeight: 200,
                          itemHeight: 30,
                        }}
                        className="border-0"
                        onSelectionChange={setSelCustomColumn}
                      >
                        {(templateSetting).map((ele) => (<ListboxItem
                          key={ele.tb_col_name}
                          startContent={<FontAwesomeIcon className="text-xs" icon={faDotCircle} ></FontAwesomeIcon>}
                        >{ele.xl_col_name}</ListboxItem>))}


                      </Listbox>
                    </ListboxWrapper>
                  </div>
                </PopoverContent>
              </Popover>
              <Button size="sm" isDisabled={finalRows.length <= 0 ? true : false} color="success"
                startContent={<FontAwesomeIcon icon={faFileExcel} />}
                onPress={exportExcel}>Export Excel</Button>
              {/* <Button size="sm" isDisabled={rows.length <= 0 ? true : false} color="danger"
              startContent={<FontAwesomeIcon icon={faFilePdf} />}
              onPress={exportPdf}>Export PDF</Button> */}
            </div>
          </div>

          <div className="flex gap-2 mb-2 justify-end items-center">
            {hasInwardDate && (
              <label className="flex  bg-blue-50 items-center gap-3 cursor-pointer p-2 rounded-md hover:bg-gray-50 transition">
                <input
                  type="checkbox"
                  checked={columnVisibilityModel.inw_date}
                  onChange={handleCheckboxChange}
                  disabled={finalRows.length > 0 ? false : true}
                  className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-2 focus:ring-blue-500"
                />
                <span className="text-xs text-blue-600  uppercase font-semibold ">
                  Show INW Date
                </span>
              </label>)}
            {stoneAgeData && stoneAgeData.length > 0 && (
              <Select
                size="sm"
                name={"stoneAge"}
                label={"Stone Age"}
                selectionMode="single"
                // labelPlacement="outside"
                placeholder={"-Select-"}
                className="w-32 bg-white  font-semibold"
                classNames={{
                  label: "text-xs p-1 m-0 text-black font-bold",
                }}
                isClearable={true}
                variant="light"
                isDisabled={data.length > 0 ? false : true}
                color="danger"
                selectedKeys={[selStoneAge]}
                items={
                  stoneAgeData || []
                }
                onChange={(e) => setSelStoneAge(e.target.value)}
              >
                {(list) => (
                  <SelectItem
                    key={String(list.Color_Code)}
                    textValue={`> ${list.From_Days - 1}`}
                  >
                    <div className="flex gap-2 items-center">
                      <FontAwesomeIcon
                        style={{
                          color: list?.Color_Code || "#585656",
                          fontSize: "0.8rem"
                        }}
                        icon={faSquare}
                      />
                      {`> ${list.From_Days - 1}`}
                    </div>
                  </SelectItem>
                )}
              </Select>)}
            < Input size="sm" placeholder="" label="MARKUP ( % ) :" labelPlacement="outside-left" variant="flat"
              color="danger"
              type="text"
              className="w-40 text-xs"
              classNames={{ "label": "font-semibold" }}
              onChange={handleMarkupChange}
              isDisabled={finalRows.length > 0 ? false : true}
              value={markupPer}

            >  </Input>
            {isBarcodePrint ? <>
              <Input size="sm" placeholder="From" label="PKT NO." labelPlacement="outside-left" variant="bordered"
                className="w-36 font-semibold"
                onChange={(e) => handlePktNoChange(e.target.value, "fPktNo")}
                value={fromPktNo}

              >  </Input>
              <Input size="sm" placeholder="To" label="" labelPlacement="outside-left" variant="bordered"
                className="w-20"
                onChange={(e) => handlePktNoChange(e.target.value, "tPktNo")}
                value={toPktNo}

              >  </Input>

              <Button size="sm" className="bg-blue-700" color="danger"
                startContent={<FontAwesomeIcon icon={faBarcode} />}

                isDisabled={finalRows.length > 0 && fromPktNo != "" && fromPktNo != null && toPktNo != "" && toPktNo != null ? false : true}
                onPress={handleMuliBarcode}>Print</Button>

            </> : ""}

          </div>


          {data && data.length > 0 ?
            <>
              <Input type="text" radius="none" placeholder="Search...."
                startContent={<FontAwesomeIcon className="text-gray-700" icon={faSearchPlus}></FontAwesomeIcon>}
                variant="bordered" className="bg-white border-1 border-gray-300" value={searchTerm} onChange={handleSearchChange} ></Input>
              {selectedRows && selectedRows.length > 0 ?
                <div className="text-red-700 text-sm p-0 m-0" >Total Selected Packets:{selectedRows.length}</div> : ""}
              <Box sx={{ height: finalRows.length > 30 ? 500 : "auto", width: '100%' }}>
                <DataGrid
                  rows={finalRows}
                  columns={renderColumns}
                  columnHeaderHeight={80}
                  rowHeight={30}
                  disableColumnMenu={true}
                  disableColumnSorting={false}
                  disableColumnResize={false}
                  sortModel={sortModel}
                  checkboxSelection={true}
                  onRowSelectionModelChange={handleRowSelectionChange}
                  rowSelectionModel={selectedRows}
                  pageSizeOptions={[25, 50, 75, 100]}   // Options user can pick

                  initialState={{
                    pagination: {
                      paginationModel: { pageSize: 50, page: 0 },
                    },
                  }}
                  pagination

                  getRowId={(row) => row.id}

                  // columnVisibilityModel={{
                  //   "rapamount": false,
                  //   "inw_date": isInwDateVisible ? true : false
                  // }}
                  columnVisibilityModel={columnVisibilityModel}
                  onColumnVisibilityModelChange={(newModel) =>
                    setColumnVisibilityModel(newModel)
                  }

                  getRowClassName={(params) => {
                    if (CurrencySetting != ENUM_CURRENCY_SETTING_VAL.RS)
                      return params.row.brated <= 0 ? "price-zero-row" : "row-class"
                    else
                      return params.row.brate <= 0 ? "price-zero-row" : "row-class"

                  }}
                  sx={{
                    "& .price-zero-row": {
                      backgroundColor: "#ffdede", // red-100
                      color: "#be1b06ff",
                      fontSize: "11px",

                      "&:hover": {
                        backgroundColor: "#ffffff"
                      }
                    },
                    '& .MuiDataGrid-columnHeaders': {
                      position: 'sticky',
                      top: 0,
                      backgroundColor: "#d4e6d13f",
                      zIndex: 1,
                    },
                    '& .sticky-row': {
                      position: 'sticky',
                      bottom: 0,
                      color: "#FFFFFF",
                      backgroundColor: '#424242f5',
                      zIndex: 10,
                      fontSize: "12px"
                    },
                    '& .row-class:hover': {
                      backgroundColor: '#ffeabc',
                    },
                    '& .row-class': {
                      fontSize: '11px',
                      backgroundColor: '#fff',
                    },
                    '& .MuiDataGrid-columnHeader .MuiDataGrid-sortIcon': {
                      display: 'none',
                    },
                    '& .MuiDataGrid-columnHeader .MuiDataGrid-iconSeparator': {
                      display: 'none',
                    },
                    '& .MuiDataGrid-columnHeader .MuiDataGrid-iconButtonContainer': {
                      display: 'none',
                    },
                    '& .MuiDataGrid-columnHeader, & .MuiDataGrid-cell': {
                      paddingLeft: 0,
                      paddingRight: 0,
                      marginLeft: 0,
                      marginRight: 0,
                    },
                    '& .MuiDataGrid-columnHeaderDraggableContainer': {
                      backgroundColor: "#eceff1"
                    },
                    '& .MuiDataGrid-footerContainer': {
                      backgroundColor: "#eceff1"
                    }

                  }}

                />
              </Box>

              <div className={`flex ${isMobile ? "flex-wrap" : ""} shadow gap-4 py-5 px-2 mt-3  mb-10 border-1 bg-white`}>
                <div className="flex gap-4">
                  <Input size="sm" readOnly={true} label=" Total" labelPlacement="outside" color="danger"
                    className="max-w-28 font-semibold" value={totalPcs}

                  > </Input>
                  <Input size="sm" readOnly={true} label=" Weight" labelPlacement="outside" color="danger"
                    className="max-w-28 font-semibold" value={totalWeight}

                  > </Input>
                </div>
                <div className="flex gap-4">
                  <Input size="sm" readOnly={true} label="Total Amt($) Rap" labelPlacement="outside" color="danger"
                    className="max-w-40 font-semibold"
                    value={funCheckNumber(((totalRap - totalAmountD) / totalAmountD * 100).toFixed(2))}
                    startContent={
                      <div className="pointer-events-none flex items-center">
                        <span className="text-default-400 text-small">$</span>
                      </div>
                    }
                  > </Input>

                  <Input size="sm" readOnly={true} label="Avg Rate($) " labelPlacement="outside" color="warning"
                    className="max-w-26 font-semibold"
                    value={avgRate}
                    startContent={
                      <div className="pointer-events-none flex items-center">
                        <span className="text-default-400 text-small">$</span>
                      </div>
                    }
                  > </Input>
                  <Input size="sm" readOnly={true} label="Avg Rate(₹) " labelPlacement="outside" color="warning"
                    className="max-w-26 font-semibold"
                    value={avgRateRs}
                    startContent={
                      <div className="pointer-events-none flex items-center">
                        <span className="text-default-400 text-small">₹</span>
                      </div>
                    }
                  > </Input>
                  <Input size="sm" label="Conv. Rate" labelPlacement="outside" color="danger"
                    className="max-w-20 text-rose-700"
                    value={selConvRate}
                    variant="bordered"
                    classNames={{ label: "text-rose-700 font-semibold " }}
                    onChange={(e) => handleConvRate(e.target.value)}
                    startContent={
                      <div className="pointer-events-none flex items-center">
                        <span className="text-default-400 text-small">₹</span>
                      </div>
                    }
                  >  </Input>
                </div>
                <div className="flex gap-4">
                  <Input size="sm" readOnly={true} label="Total Amt($)" labelPlacement="outside" color="success"
                    className="max-w-40 font-semibold"
                    value={totalAmountD}
                    startContent={
                      <div className="pointer-events-none flex items-center">
                        <span className="text-default-400 text-small">$</span>
                      </div>
                    }
                  > </Input>
                </div>
                <Input size="sm" readOnly={true} label="Total Amt" labelPlacement="outside" color="success"
                  className="max-w-40 font-semibold"
                  value={totalAmount}

                  startContent={
                    <div className="pointer-events-none flex items-center">
                      <span className="text-default-400 text-small">₹</span>
                    </div>
                  }
                >  </Input>

              </div>
            </>
            : <h2 className="text-center text-gray-400">No Records </h2>}
        </div>
        {/* : <h2>Data Not Fount</h2>
        } */}
      </MainContainer >
    </div >
  )
}

export default StockReport


//  chkselectedRowsData.forEach(diamond => {
//         htmlContent += `
//         <div class="diamond-card">
//           <div class="left-side">
//             <div>
//               <div class="diamond-title">${diamond.s_code} ${diamond.bweight}</div>
//               <div class="diamond-info">COLOR : ${diamond.sha_code}</div>
//               <div class="diamond-info">CLEARITY : ${diamond.q_code}</div>
//               <div class="diamond-info">TA : ${diamond.ta || ''}</div>
//               <div class="diamond-info">TD : ${diamond.td || ''}</div>
//             </div>
//             <div class="barcode-container">
//               <svg id="barcode-${diamond.l_code}-${diamond.pktno}" class="barcode"></svg>
//             </div>
//           </div>

//           <div class="right-side">
//             <div class="diamond-info">${diamond.l_code}-${diamond.pktno}</div>
//             <div class="diamond-info">CUT : ${diamond.cut}</div>
//             <div class="diamond-info">POL : ${diamond?.polish  ||''}}</div>
//             <div class="diamond-info">SYM : ${diamond?.symtry || ''}</div>
//             <div class="diamond-info">FL : ${diamond?.flrn || ''}</div>
//             <div class="diamond-info">DIA : ${diamond?.mrsmnt ||''}</div>
//             <div class="diamond-info">RATIO : ${diamond?.lwratio || ''} %</div>
//             <div class="diamond-info">Report No : ${diamond?.reportno || ''}</div>
//           </div>
//         </div>
//       `;
//       });